import { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { EVENTS as E } from '../constants';
import { selectPlan } from '../store/plans';
import { useEventNameConstructor } from './useEventNameConstructor';
import { useSendEvents } from './useSendEvents';

export const useCheckoutScreenEvents = (screenId: string) => {
  const sendEvents = useSendEvents({ screenId });
  const getEventName = useEventNameConstructor({ screenId });
  const plan = useSelector(selectPlan);

  useLayoutEffect(() => {
    sendEvents(E.CHECKOUT_SHOWN);
    sendEvents(E.CHECKOUT_SCREEN_LOAD);
    sendEvents(getEventName(E.LOAD), { [E.SL]: 'checkout' });
    window?.ttq?.track('InitiateCheckout', { content_id: plan });
    // Screen view events are sent once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
